module.exports = __webpack_public_path__ + "static/img/literacy.4b4cff52.jpg";